// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1638b021","455":"592ec328","977":"eff29fb1"}[chunkId] + ".chunk.js";
};